(function(){
  function init(root){
    var tr=root.querySelector('[data-rs-track]'); if(!tr||tr.dataset.ready) return; tr.dataset.ready='1';
    var cards=tr.querySelectorAll('.rs-card'), prev=root.querySelector('[data-rs-prev]'), next=root.querySelector('[data-rs-next]'), dotsBox=root.querySelector('[data-rs-dots]');
    if(!cards.length) return;
    function step(){ return cards.length>1 ? cards[1].offsetLeft-cards[0].offsetLeft : tr.clientWidth; }
    function perView(){ return Math.max(1,Math.round(tr.clientWidth/step())); }
    function pages(){ return Math.max(1,cards.length-perView()+1); }
    function sync(){
      var idx=Math.round(tr.scrollLeft/step()), max=tr.scrollWidth-tr.clientWidth-2;
      if(dotsBox) [].forEach.call(dotsBox.children,function(d,i){ d.setAttribute('aria-current',i===Math.min(idx,pages()-1)?'true':'false'); });
      if(prev) prev.disabled=tr.scrollLeft<=2;
      if(next) next.disabled=tr.scrollLeft>=max;
    }
    function buildDots(){
      if(!dotsBox){ sync(); return; }
      dotsBox.innerHTML='';
      for(var i=0;i<pages();i++){ (function(i){ var d=document.createElement('button'); d.type='button'; d.setAttribute('aria-label','Go to review '+(i+1));
        d.addEventListener('click',function(){ tr.scrollTo({left:i*step()}); }); dotsBox.appendChild(d); })(i); }
      sync();
    }
    if(prev) prev.addEventListener('click',function(){ tr.scrollBy({left:-step()}); });
    if(next) next.addEventListener('click',function(){ tr.scrollBy({left:step()}); });
    tr.addEventListener('scroll',function(){ requestAnimationFrame(sync); },{passive:true});
    tr.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){e.preventDefault();tr.scrollBy({left:step()});} if(e.key==='ArrowLeft'){e.preventDefault();tr.scrollBy({left:-step()});} });
    addEventListener('resize',buildDots); buildDots();
    var auto=parseInt(root.dataset.autoplay||'0',10);
    if(auto>0){ setInterval(function(){ if(root.matches(':hover')) return; var max=tr.scrollWidth-tr.clientWidth-2; if(tr.scrollLeft>=max) tr.scrollTo({left:0}); else tr.scrollBy({left:step()}); }, auto*1000); }
  }
  function all(){ document.querySelectorAll('.md-reviews').forEach(init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('.md-reviews'); if(r) init(r); });
  document.addEventListener('shopify:block:select',function(e){ var c=e.target; if(c.classList&&c.classList.contains('rs-card')){ var t=c.parentElement; t.scrollTo({left:c.offsetLeft-t.offsetLeft}); } });
})();
